import base2 from './base2.repository';

export default {
    get: (params) => base2.get('clients/incident-risk-types', params),
    getById: (id) => base2.get(`clients/incident-risk-types/${id}`),
    save: (payload) => base2.post('clients/incident-risk-types', payload),
    update: (id, payload) => base2.put(`clients/incident-risk-types/${id}`, payload),
    delete: (id) => base2.delete(`clients/incident-risk-types/${id}`),
}

